import React from 'react';
import './LogoSlider.css';

const LogoSlider = ({ title, description, logos }) => {
  return (
    <section className="logo-slider">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="slider-container">
          <div className="slider-track">
            {logos.map((logo, index) => (
              <div className="slide" key={index}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {logos.map((logo, index) => (
              <div className="slide" key={`dup-${index}`}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;